/* global axios */
import ApiClient from '../ApiClient';

class TwentyAPI extends ApiClient {
  constructor() {
    super('integrations/twenty', { accountScoped: true });
  }

  getContactDetails({ email, phone, conversationId, contactId, personId }) {
    const params = new URLSearchParams();
    if (personId) params.append('person_id', personId);
    if (email) params.append('email', email);
    if (phone) params.append('phone', phone);
    if (conversationId) params.append('conversation_id', conversationId);
    if (contactId) params.append('contact_id', contactId);

    return axios.get(`${this.url}/contact_details?${params.toString()}`);
  }

  createTask(data) {
    return axios.post(`${this.url}/create_task`, { task: data });
  }

  createOpportunity(data) {
    return axios.post(`${this.url}/create_opportunity`, { opportunity: data });
  }

  syncContact(contactId) {
    return axios.post(`${this.url}/sync_contact`, { contact_id: contactId });
  }

  bulkSync() {
    return axios.post(`${this.url}/bulk_sync`);
  }

  getBulkSyncStatus() {
    return axios.get(`${this.url}/bulk_sync_status`);
  }

  getSettings() {
    return axios.get(`${this.url}/settings`);
  }

  updateSettings(data) {
    return axios.post(`${this.url}/update_settings`, data);
  }
}

export default new TwentyAPI();
